import React, { useEffect, useState } from "react";
import claudeLogo from "../../../public/img/claude-color.svg";

function fmt(ms) {
  const s = Math.max(0, Math.round(ms / 1000));
  return s < 60 ? `${s}s` : `${Math.floor(s / 60)}m ${s % 60}s`;
}

/**
 * One model request's thinking phase. Managed Agents never returns the
 * reasoning text (agent.thinking is a bare progress signal), so this shows
 * what the API does give us: that Claude is thinking right now and for how
 * long, collapsing to "Thought for …" once text or a tool call starts.
 * No dropdown: there is no reasoning text to show.
 */
export default function ThinkingItem({ item, running = false, showAvatar = true }) {
  const [now, setNow] = useState(Date.now());
  useEffect(() => {
    if (!running) return undefined;
    const id = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(id);
  }, [running]);
  const elapsed = (item.endedAt ?? now) - item.startedAt;
  const label = running ? `Thinking… ${fmt(elapsed)}` : `Thought for ${fmt(elapsed)}`;
  return (
    <div className={`ca-step ca-step--thinking ${running ? "running" : ""}`}>
      <div className="ca-msg-avatar" aria-hidden="true">
        {showAvatar && <img src={claudeLogo} alt="" />}
      </div>
      <div className="ca-step-main">
        <div className="ca-step-row ca-step-row--static">
          <span className={`ca-step-label ${running ? "ca-step-shimmer" : ""}`}>{label}</span>
        </div>
      </div>
    </div>
  );
}
